import { useContext, useEffect, useState } from 'react';

import {
  Card,
  Col,
  CardBody,
  Form,
  Row,
  FormGroup,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';

import api from 'services/api';
import Proposta from 'models/Proposta';
import { PropostaContext } from 'views/pages/Proposta';
import Swal from 'sweetalert2';

interface IObservacao {
  proposta: Proposta;
  propostaVersaoId: number;
}

export default function Observacao({
  proposta,
  propostaVersaoId,
}: IObservacao): JSX.Element {
  const { propostaVersao, carregaPropostaVersao } = useContext(PropostaContext);
  const [updatingObservacao, setUpdatingObservacao] = useState(false);

  const [observacao, setObservacao] = useState(propostaVersao.observacao || '');

  /**
   *
  useEffect(() => {
    setObservacao(propostaVersao.observacao || '');
  }, [propostaVersao]);
  */

  async function handleUpdateObservacao() {
    if (!propostaVersaoId || !proposta.id) return;

    Swal.fire({
      title: `Essa informação será levada à proposta. Deseja prosseguir?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        setUpdatingObservacao(true);
        Swal.fire({
          icon: 'info',
          text: `Salvando observação.`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });
        await api.put(`/proposta/${propostaVersaoId}/observacao`, {
          observacao,
          propostaId: proposta.id,
        });
      }
      Swal.close();
      setUpdatingObservacao(false);
      carregaPropostaVersao();
    });
  }

  useEffect(() => {
    carregaPropostaVersao();
  }, []);

  return (
    <>
      <Card className="bg-secondary shadow mt-1 mb-1">
        <CardBody>
          <Form>
            <div className="pl-lg-3">
              <Row>
                <Col sm="6" lg="6" xs="6">
                  <FormGroup className="mb-3">
                    <label
                      className="form-control-label"
                      htmlFor="example-date-input"
                    >
                      Observação
                    </label>

                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i
                            className="ni ni-align-center"
                            style={{
                              alignSelf: 'start',
                              marginTop: '0.3rem',
                            }}
                          />
                        </InputGroupText>
                      </InputGroupAddon>

                      <Input
                        placeholder="Observação"
                        value={observacao}
                        rows="2"
                        type="textarea"
                        name="observacao"
                        disabled={updatingObservacao}
                        onChange={text => setObservacao(text.target.value)}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col sm="4" lg="4" xs="4" />
                <Col sm="1">
                  <Button
                    className="float-right mt-4"
                    color="default"
                    onClick={handleUpdateObservacao}
                  >
                    {updatingObservacao ? 'Salvando...' : 'Salvar'}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </CardBody>
      </Card>
    </>
  );
}
